module.exports = __webpack_public_path__ + "media/images/850/about-f45a572298005a69e1e1defe96f81cf5.jpg";